import React from 'react';
import { pdfjs } from 'react-pdf';
import PdfViewer from './PdfViewer';

pdfjs.GlobalWorkerOptions.workerSrc = '/worker.js';

const Viewer = ({ zoom, url, docFileId, docId, editortype, docFiles, timerOnDoc, onLoadSuccess, showToolbar, setZoomIndex, statHook, scrollActive, tlb, pageNum }) => {
const elemClick = statHook?.elemClick;

 React.useEffect(() => {
   if (!elemClick) return;
   const tryAttach = () => {
     const cand = document.getElementById('download-pdf') || document.getElementById('download');
     if (!cand) return false;
     const h = (e) => elemClick('download-pdf', e);
     cand.addEventListener('click', h, true);
     return () => cand.removeEventListener('click', h, true);
   };
   const cleanup = tryAttach();
   if (cleanup) return cleanup;
 }, [elemClick]);

    return (
        <>
            <PdfViewer
                pdfFile={url}
                statHook={statHook}
                zoom={zoom}
                docFileId={docFileId}
                docId={docId}
                onLoadSuccess={onLoadSuccess}
                editortype={editortype}
                docFiles={docFiles}
                timerOnDoc={timerOnDoc}
                showToolbar={showToolbar}
                setZoomIndex={setZoomIndex}
                tlb={tlb}
                pageNum={pageNum}
            />
        </>
    );
};

export default Viewer;